import  gql  from 'graphql-tag'

export const professions = gql`query {
        professions{
            edges{
                node{
                    code
                    name
                }
            }
        }
    }`;
